// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-career/career-saved-component/career-saved-component.component.scss
// module id = 668
// module chunks = 0